import { CEWorkBase } from './ce-work-base'


export class CEWork extends CEWorkBase {

}